import { SelectProps } from 'antd';
import { VFC, useMemo } from 'react';
import {
  Commodity,
  ElectricityRegister,
  GasRegister,
  OtherRegister,
  ThermalRegister,
  WaterRegister,
} from '@enmon/commons/lib/shared';
import { Select } from './Select';

interface ObisSelectProps extends SelectProps {
  commodity: Commodity | null;
}

export const ObisSelect: VFC<ObisSelectProps> = ({ commodity, ...props }) => {
  const options = useMemo(() => {
    switch (commodity) {
      case Commodity.Electricity:
        return Object.values(ElectricityRegister).map(obis => ({
          value: obis,
          label: obis,
        }));
      case Commodity.NaturalGas:
        return Object.values(GasRegister).map(obis => ({
          value: obis,
          label: obis,
        }));
      case Commodity.Thermal:
        return Object.values(ThermalRegister).map(obis => ({
          value: obis,
          label: obis,
        }));
      case Commodity.Water:
        return Object.values(WaterRegister).map(obis => ({
          value: obis,
          label: obis,
        }));
      case Commodity.Other:
        return Object.values(OtherRegister).map(obis => ({
          value: obis,
          label: obis,
        }));
      default:
        console.warn(`Unsupported commodity for OBIS selection: ${commodity}`);
        return [];
    }
  }, [commodity]);

  return <Select options={options} {...props} className="w-100" dropdownMatchSelectWidth={false} placeholder="1.8" />;
};
